import { useAppDispatch, useAppSelector } from '@/shared/hooks';

import { selectors, thunks } from '../model';

type StaleCandidate = { id: string; status: string };

/**
 * A recording the server still reports as `recording` while this browser has
 * no active session for it was interrupted (tab closed, crash); the user can
 * stop it and send it for processing.
 */
export const useStaleConsultationDetection = () => {
  const dispatch = useAppDispatch();
  const isActiveRecording = useAppSelector(selectors.selectIsRecording);
  const isActiveInterrupted = useAppSelector(selectors.selectIsInterrupted);
  const isActiveProcessing = useAppSelector(selectors.selectIsProcessing);
  const activeConsultationId = useAppSelector(selectors.selectConsultationId);

  const isConsultationStale = (consultation: StaleCandidate) =>
    consultation.status === 'recording' &&
    !isActiveRecording &&
    !isActiveInterrupted &&
    !isActiveProcessing &&
    consultation.id !== activeConsultationId;

  const forceStop = (consultationId: string) => {
    dispatch(thunks.forceStopStaleConsultation(consultationId));
  };

  return { isConsultationStale, forceStop };
};
